'use strict';
import QS from 'qs'
import Axios from 'axios'
import url from '@/utils/server'
const baseurl = url.apiurl
const baseurl2 = url.apiurl2
// 本项目不需要太多的拦截,故此剔除了很多拦截内容

// http request 拦截器
Axios.interceptors.request.use(
    (config) => {
       console.log("config",config)
       if(config.timeout == 40000){
        config.baseURL = baseurl2
       }else{
        config.baseURL = baseurl
       }
        
        if (!config['params']) {
            config['params'] = {}
        }
       // config.params['token'] = ''
        config.headers['token'] = ''
        return config
    },
    (err) => {
        return Promise.reject(err)
    }
)

// 添加响应拦截器
Axios.interceptors.response.use(
    (res) => {
        return res.data
    },
    (error) => {
        return Promise.reject(error);
    }
)
export default {
    getter: (option) => {
        var options = {
            url: option.url,
            timeout: 40000,
            method: option.method || 'get',
            params: option.data || {},
            success: option.succ || function(res) {},
            error: option.error || function(res) {},
        }
        return Axios.request(options)
    },
    get: (option) => {
        var options = {
            url: option.url,
            timeout: 10000,
            method: option.method || 'get',
            params: option.data || {},
            success: option.succ || function(res) {},
            error: option.error || function(res) {},
        }
        return Axios.request(options)
    },
    post: (option) => {
        var options = {
            url: option.url,
            timeout: 1000000,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            method: option.method || 'post',
            data: option.data,
            success: option.succ || function(res) {},
            error: option.error || function(res) {}
        }
        if (option.data && option.typea == 1) {
            options.headers['content-Type'] = 'application/json;charset=utf-8'
            options.beforeSend = function(xhr) {
                xhr.setRequestHeader("Test", "testheadervalue");
            }
        } else if (option.data && option.typeb == 'excel') {
            options.responseType = 'blob';
            options.data = QS.stringify(options.data)
        } else if (option.data && option.typea == 2) {
            options.headers['content-Type'] = 'multipart/form-data'
        } else {
            options.data = QS.stringify(options.data)
        }
        return Axios.request(options)
    },
    delete: (option) => {
        var options = {
            url: option.url,
            timeout: 10000,
            method: option.method || 'delete',
            params: option.data || {},
            success: option.succ || function (res) {},
            error: option.error || function (res) {},
        }
        return Axios.request(options)
    },
    put: (option) => {
        var options = {
            url: option.url,
            timeout: 10000,
            method: option.method || 'PUT',
            params: option.data || {},
            success: option.succ || function (res) {},
            error: option.error || function (res) {},
        }
        return Axios.request(options)
    },
}